import type { QuestionsFromAudienceStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionQuestionsFromAudienceProperty = (
  target: CompatibilitySlide | VotingSlide,
  prop: keyof Question,
) => {
  const staticContents =
    target.staticContent as QuestionsFromAudienceStaticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question_description':
      return staticContents.additionalDetails;
    case 'question':
      return target.title;
    case 'question_styled':
      return staticContents.styledTitle ?? {};
    default:
      return undefined;
  }
};
